import CustomSelect, { CustomSelectItem } from 'components/custom-ui/CustomSelect'
import React from 'react'
import{ useStateManager } from "bcms-react";
import "./styles.css";

/**
 * @function UINotifiTimePicker
 * @param {STRING} className - Set additional class names.
 * @return {React.Component}
 * @exported true
 * @description This is the day picker used in QuietTimesWidget and ScheduleAlertWidget components.
 * @example
 * <UINotifiTimePicker className="test-name" />
 */
export default function UINotifiTimePicker(props) {
  const type = props.type ?? "";
  const alertDetail = props.alertDetail ?? {};
  const scheduledTime = props.scheduledTime ?? {};
  const className = props.className ?? "";
  const updateTimeOfDay = props.updateTimeOfDay ?? (() => {});
  let hour = scheduledTime.hour === "" ? "HH" : scheduledTime.hour;
  let minute = scheduledTime.minute === "" ? "MM" : scheduledTime.minute;
  let timeOfDay = scheduledTime.timeOfDay === "" ? "AM" : scheduledTime.timeOfDay;

  /*if(type !== "") {
    hour = timeDetail[`${ type }Hour`] === "" ? "HH" : timeDetail[`${ type }Hour`];
    minute = timeDetail[`${ type }Minute`] === "" ? "MM" : timeDetail[`${ type }Minute`];
    timeOfDay = timeDetail[`${ type }TimeOfDay`] === "" ? "AM" : timeDetail[`${ type }TimeOfDay`];
  } */

  const hoursSelectItems = Array.from({ length: 12 }, (_, i) => {
    return i >= 9 ? `${ i + 1 }` : `0${ i + 1 }`;
  })
  .reduce((acc, item, i) => {
    if(i === 0) acc.push(<CustomSelectItem className="placeholder-option" key="HH" value="HH">HH</CustomSelectItem>);
    acc.push(<CustomSelectItem key={ `${ item }` } value={ `${ item }` }>{ `${ item }` }</CustomSelectItem>);
    return acc;
  }, []);

  const minutesSelectItems = Array.from({ length: 60 }, (_, i) => {
    return i > 9 ? `${ i }` : `0${ i }`;
  })
  .reduce((acc, item) => {
    if(item === "00") acc.push(<CustomSelectItem className="placeholder-option" key="MM" value="MM">MM</CustomSelectItem>);
    acc.push(<CustomSelectItem key={ `${ item }` } value={ `${ item }` }>{ `${ item }` }</CustomSelectItem>);
    return acc;
  }, []);

  const timeOfDaySelectItems = [ "AM", "PM" ]
  .reduce((acc, item) => {
    acc.push(<CustomSelectItem key={ `${ item }` } value={ `${ item }` }>{ `${ item }` }</CustomSelectItem>);
    return acc;
  }, []);

  return (
    <div className={`ui-notifi-time-picker flex-container flex-horizontal ${className}`}>
      <CustomSelect className="hour-select-container" value={ hour } onChange={ updateTimeOfDay(alertDetail.id, "hour", type) }>
        { hoursSelectItems }
      </CustomSelect>
      <CustomSelect className="minute-select-container" value={ minute } onChange={ updateTimeOfDay(alertDetail.id, "minute", type) }>
        { minutesSelectItems }
      </CustomSelect>
      <CustomSelect className="am-pm-select-container" value={ timeOfDay } onChange={ updateTimeOfDay(alertDetail.id, "timeOfDay", type) }>
        { timeOfDaySelectItems }
      </CustomSelect>
    </div>
  )
}
